import {
  SEND_REGISTER_EMAIL_OTP_REQUEST,
  SEND_REGISTER_EMAIL_OTP_SUCCESS,
  SEND_REGISTER_EMAIL_OTP_FAIL,
  VERIFY_REGISTER_EMAIL_OTP_REQUEST,
  VERIFY_REGISTER_EMAIL_OTP_SUCCESS,
  VERIFY_REGISTER_EMAIL_OTP_FAIL,
  LOAD_USER_REQUEST,
  LOAD_USER_SUCCESS,
  LOAD_USER_FAIL,
  LOGOUT_SUCCESS,
  LOGOUT_FAIL,
  CLEAR_ERRORS,
} from "../constant/userConstants";

import axios from "axios";
import baseUrl from "../../api/baseUrl";
// sendOtpEmailRegister
export const sendOtpEmailRegister = (userData) => async (dispatch) => {
  try {
    dispatch({ type: SEND_REGISTER_EMAIL_OTP_REQUEST });

    const config = { headers: { "Content-Type": "application/json" } };
    const { data } = await axios.post(
      `${baseUrl}/auth/register-and-send-otp`,
      { ...userData },
      config
    );

    console.log(data);
    dispatch({ type: SEND_REGISTER_EMAIL_OTP_SUCCESS, payload: data.message });
  } catch (error) {
    dispatch({
      type: SEND_REGISTER_EMAIL_OTP_FAIL,
      payload: error.response.data.message,
    });
  }
};

// VerifyOtpEmailRegister
export const verifyOtpEmailRegister = (userData) => async (dispatch) => {
  try {
    dispatch({ type: VERIFY_REGISTER_EMAIL_OTP_REQUEST });

    const config = { headers: { "Content-Type": "application/json" } };
    const { data } = await axios.post(
      `${baseUrl}/auth/verify-and-register-user`,
      { ...userData },
      config
    );

    console.log(data);
    dispatch({ type: VERIFY_REGISTER_EMAIL_OTP_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: VERIFY_REGISTER_EMAIL_OTP_FAIL,
      payload: error.response.data.message,
    });
  }
};

// Load User
export const loadUser = () => async (dispatch) => {
  try {
    dispatch({ type: LOAD_USER_REQUEST });

    const { data } = await axios.get(`${baseUrl}/auth/user-profile/`);
    console.log("load user data", data);
    dispatch({ type: LOAD_USER_SUCCESS, payload: data.user });
  } catch (error) {
    console.log("this is error", error);
    dispatch({ type: LOAD_USER_FAIL, payload: error.response.data.message });
  }
};

// Logout User
export const logout = () => async (dispatch) => {
  try {
    const { data } = await axios.get(`${baseUrl}/auth/logout`);

    dispatch({ type: LOGOUT_SUCCESS });
  } catch (error) {
    dispatch({ type: LOGOUT_FAIL, payload: error.response.data.message });
    console.log("this is error", error);
  }
};

// Clearing Errors
export const clearErrors = () => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
};
